import React from 'react'
import { Table } from 'react-bootstrap'
import RecordsTableRow from './records-table-row'
import Selector from './selector'
import Checkbox from '../../common/checkbox'

const RecordsTable = ({
    records = [],
    onColmunChange = () => {},
    fieldOptions = [],
    columns = [],
    onToggleRecord = () => {},
    selectedRecords=[],
    toggleAll = () => {}
}) => {

    if (!records.length) {
        return null
    }

    const renderRecord = (columnNames = [], key) => {
        return (
            <RecordsTableRow
                key={key}
                columns={columnNames}
                onToggle={value => onToggleRecord(key, value)}
                selected={selectedRecords.includes(key)}
                disabled={!columns.some(c => c)}
            />
        )
    }

    const renderColumn = (column, key) => {
        return (
            <th key={key}>
                <Selector
                    options={fieldOptions}
                    value={columns[key]}
                    onChange={value => onColmunChange(key, value)}
                />
            </th>
        )
    }

    return (
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <Table bordered={columns.length && records.length} hover={columns.length && records.length} >
                <thead>
                    <tr>
                        <th style={{ width: '10px'}}>
                            <Checkbox checked={selectedRecords.length === records.length} onChange={selected => toggleAll(selected)} />
                        </th>
                        {columns.map(renderColumn)}
                    </tr>
                </thead>
                <tbody>{records.map(renderRecord)}</tbody>
            </Table>
        </div>
    )
}

export default RecordsTable
